import {
  FETCH_ATTRIBUTES_BEGIN,
  FETCH_ATTRIBUTES_SUCCESS,
  FETCH_ATTRIBUTES_FAILURE,
  FETCH_ATTRIBUTE_SECURITY,
  FETCH_ATTRIBUTE_SECURITY_SUCCESS,
  FETCH_ATTRIBUTE_SECURITY_FAILURE,
  ATTRIBUTE_CREATED
} from './attributes.action';

import {INITIAL_STATE} from './attributes.state';

export const AttributeReducer = (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case FETCH_ATTRIBUTES_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        items: payload
      };

    case FETCH_ATTRIBUTES_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case ATTRIBUTE_CREATED:
      return {
        ...state,
        items: []
      };

    case FETCH_ATTRIBUTE_SECURITY:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_ATTRIBUTE_SECURITY_SUCCESS:
      return {
        ...state,
        loading: false,
        isSecuredLoaded: true,
        secured: payload
      };

    case FETCH_ATTRIBUTE_SECURITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload
      };

    default:
      return state;
  }
};
